/* <product-back-link>: the way back from a product page.

   The server renders the hierarchy category or the browsed collection
   (snippets/product-back-link.liquid). When the visitor arrived from the
   brand's own page, the link points back there instead, so a round trip
   from a brand page closes where it started. The decision is the referrer:
   same origin and the brand page's path (locale prefix ignored). The
   element carries the target as data attributes; without them, or without
   a matching referrer, the server-rendered link stays as it is. */
if (!customElements.get('product-back-link')) {
  customElements.define(
    'product-back-link',
    class ProductBackLink extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.worldUrl;
        const label = this.dataset.worldLabel;
        const link = this.querySelector('a');
        if (!url || !label || !link) return;

        let referrer;
        let target;
        try {
          referrer = new URL(document.referrer);
          target = new URL(url, window.location.origin);
        } catch {
          return;
        }
        if (referrer.origin !== window.location.origin) return;
        if (!ProductBackLink.samePage(referrer.pathname, target.pathname)) return;

        link.href = url;
        const text = link.querySelector('.product-back-link__label');
        if (text) text.textContent = label;
      }

      // "/en/pages/salomon" and "/pages/salomon/" are the same page.
      static samePage(a, b) {
        const strip = (p) => p.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '').replace(/\/+$/, '');
        return strip(a) === strip(b);
      }
    },
  );
}
